import {Alert, Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Container, FormControl, Grid2 as Grid, InputLabel, Link, MenuItem, OutlinedInput, Select, Table, TableBody, TableCell, TableRow, TextField, Tooltip} from "@mui/material"
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import React from "react"
import {useNavigate} from 'react-router-dom';
import {Add, Close, Delete, Download, Edit, MarkAsUnread} from "@mui/icons-material";
import {download} from "../../services/FileService";
import VisuallyHiddenInput from "../common/VisuallyHiddenInput";
import TableHead from "@mui/material/TableHead";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TaskChatMessages from "./TaskChatMessages";
import taskService from "../../services/TaskService";
import {limit} from "../../util/StringUtils";

const columns = [
    {id: 'name', label: 'Fájl Neve'},
    {id: 'description', label: 'Leírás'},
    {id: 'createdAt', label: 'Feltöltve'},
    {id: 'uploadedBy', label: 'Feltöltő'},
];

export default function TaskEditorTemplate(props) {

    const [open, setOpen] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState(undefined);
    const [downloadInProgress, setDownloadInProgress] = React.useState(false);
    const [selectedFiles, setSelectedFiles] = React.useState([]);

    const handleClickOpen = (item) => {
        setCurrentItem(item)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const {
        id,
        projectTasks,
        projects,
        onChange,
        create,
        saveAsNew,
        update,
        message,
        users,
        clients,
        task,
        waitingForServer,
        onUsersChange,
        vehicles,
        onChangeSelectItem,
        onDateTimeChange,
    } = props

    const navigate = useNavigate();

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250
            },
        },
    };

    function getStyles(name, users) {
        if (users == null || users.map(user => user.name).indexOf(name) === -1) return
        return {
            backgroundColor: "#2e7d32",
            color: "white"
        };
    }

    function getClientsStyles(name, clients) {
        if (clients == null || clients.map(user => user.name).indexOf(name) === -1) return
        return {
            backgroundColor: "#2e7d32",
            color: "white"
        };
    }

    function downloadAllFiles() {
        setDownloadInProgress(true);
        download(limit(task?.description, 30) || "files.zip", `/cloud-storage-files`, props.sendAlertMessage, () => setDownloadInProgress(false), selectedFiles);
    }

    const onFileCheckBoxChange = (event, file) => {
        if (event?.target?.checked) {
            setSelectedFiles(prev => [...prev, file.id]);
        } else {
            setSelectedFiles(prev => prev.filter(id => id !== file.id));
        }
    }

    return (
        <div>
            <Container component="main">
                <Grid container columns={20}>
                    <Grid size={{xs: 20}}>
                        <div className="register-paper">
                            <form id="login" onSubmit={id ? update : create}>
                                <Grid container columns={20}>
                                    <Grid size={{xs: 20}}>
                                        <Grid container columnSpacing={2} rowSpacing={0} columns={30}>
                                            {id != null && task.id == null ?
                                                <Grid size={{xs: 30}}><CircularProgress sx={{margin: "200px"}}/> </Grid> :
                                                <>
                                                    {createInputField("description", "Alfeladat Leírása", task.description, onChange, false, false, false, "text", true, 30)}

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <FormControl sx={{
                                                            m: 1,
                                                            minWidth: 120,
                                                            marginTop: "16px",
                                                            marginLeft: "0px"
                                                        }} fullWidth>
                                                            <InputLabel id="priority-label">Prioritás</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                fullWidth
                                                                labelId="priority-label"
                                                                name="priority"
                                                                label="Prioritás"
                                                                value={task.priority || "NORMAL"}
                                                                defaultValue={"NORMAL"}
                                                                onChange={(e, newValue) => onChange(e, newValue.value, "priority")}
                                                                sx={{textAlign: "left"}}
                                                            >
                                                                <MenuItem value={"EXTRA_IMPORTANT"}>Extra fontos</MenuItem>
                                                                <MenuItem value={"IMPORTANT"}>Fontos</MenuItem>
                                                                <MenuItem value={"NORMAL"}>Normál</MenuItem>
                                                                <MenuItem value={"NOT_IMPORTANT"}>Nem fontos</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <FormControl sx={{
                                                            m: 1,
                                                            minWidth: 120,
                                                            marginTop: "16px",
                                                            marginLeft: "0px"
                                                        }} fullWidth>
                                                            <InputLabel id="status-label">Státusz</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                fullWidth
                                                                labelId="status-label"
                                                                name="status"
                                                                label="Státusz"
                                                                value={task.status || "NOT_STARTED"}
                                                                defaultValue={"NOT_STARTED"}
                                                                onChange={(e, newValue) => onChange(e, newValue.value, "status")}
                                                                sx={{textAlign: "left"}}
                                                            >
                                                                <MenuItem value={"NOT_STARTED"}>Nincs elkezdve</MenuItem>
                                                                <MenuItem value={"IN_PROGRESS"}>Folyamatban</MenuItem>
                                                                <MenuItem value={"BLOCKED"}>Elakadva</MenuItem>
                                                                <MenuItem value={"OVERDUE"}>Csúszásban</MenuItem>
                                                                <MenuItem value={"DONE"}>Befejezve</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 10}}>
                                                        <Autocomplete
                                                            value={task.project || null}
                                                            margin="normal"
                                                            label="Projekt Neve"
                                                            name="project"
                                                            autoHighlight
                                                            autoSelect
                                                            onChange={(event, newValue) => onChange(event, newValue, "project")}
                                                            options={projects || []}
                                                            isOptionEqualToValue={(item, other) => item.id === other.id}
                                                            getOptionLabel={(project) => project.name}
                                                            style={{marginTop: "16px"}}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Projekt Neve"/>
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid size={{xs: 20, md: 10, lg: 10}}>
                                                        <Autocomplete
                                                            value={task?.projectTask || null}
                                                            margin="normal"
                                                            label="Fejléc"
                                                            name="projectTask"
                                                            autoHighlight
                                                            disabled={task?.project?.id == null}
                                                            onChange={(event, newValue) => onChange(event, newValue, "projectTask")}
                                                            options={projectTasks || []}
                                                            getOptionLabel={(projectTask) => projectTask.description}
                                                            isOptionEqualToValue={(item, other) => item.id === other.id}
                                                            style={{marginTop: "16px"}}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Fejléc" required={task?.project != null}/>
                                                            )}
                                                        />
                                                    </Grid>

                                                    {createInputField("progressLevel", "Készültségi Szint", task.progressLevel === null ? null : task.progressLevel?.toString(), onChange, false, false, false, "number", false, 5)}
                                                    {createInputField("estimatedHours", "Becsült Órák", task.estimatedHours === null ? null : task.estimatedHours?.toString(), onChange, false, false, false, "number", false, 5)}


                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DateTimePicker label="Tervezett Kezdés"
                                                                            value={task.scheduleDateStart}
                                                                            sx={{width: "100%", marginTop: "16px"}}
                                                                            ampm={false} format="YYYY-MM-DD HH:mm"
                                                                            onChange={(newValue) => onDateTimeChange(newValue, "scheduleDateStart")}/>
                                                        </LocalizationProvider>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DateTimePicker label="Tervezett Befejezés"
                                                                            value={task.scheduleDateEnd}
                                                                            sx={{width: "100%", marginTop: "16px"}}
                                                                            ampm={false} format="YYYY-MM-DD HH:mm"
                                                                            onChange={(newValue) => onDateTimeChange(newValue, "scheduleDateEnd")}/>
                                                        </LocalizationProvider>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DateTimePicker label="Határidő"
                                                                            value={task.deadline}
                                                                            sx={{width: "100%", marginTop: "16px"}}
                                                                            ampm={false} format="YYYY-MM-DD HH:mm"
                                                                            onChange={(newValue) => onDateTimeChange(newValue, "deadline")}/>
                                                        </LocalizationProvider>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <Autocomplete
                                                            value={task.vehicle || null}
                                                            margin="normal"
                                                            disableClearable
                                                            onChange={(event, newValue) => onChangeSelectItem(newValue, "vehicle")}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            options={vehicles}
                                                            getOptionLabel={(vehicle) => vehicle.licensePlate}
                                                            style={{marginTop: "16px"}}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Jármű"/>
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <FormControl sx={{
                                                            m: 1,
                                                            minWidth: 120,
                                                            marginTop: "16px",
                                                            marginLeft: "0px"
                                                        }} fullWidth>
                                                            <InputLabel id="users-label">Jelöltek</InputLabel>
                                                            <Select
                                                                labelId="users-label"
                                                                multiple
                                                                value={task.candidates || []}
                                                                onChange={(e) => onUsersChange(e, "candidates")}
                                                                label="Jelöltek"
                                                                variant="outlined"
                                                                input={<OutlinedInput id="select-multiple-chip" label="Jelöltek"/>}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        gap: 1.0,
                                                                        margin: "-5px"
                                                                    }}>
                                                                        {selected.map((value) => (
                                                                            <Chip key={value.id} label={value.name}/>
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                                MenuProps={MenuProps}
                                                            >
                                                                {users.map((user) => (
                                                                    <MenuItem
                                                                        key={user.id}
                                                                        value={user}
                                                                        style={getStyles(user.name, task.candidates)}
                                                                    >
                                                                        {user.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <FormControl sx={{
                                                            m: 1,
                                                            minWidth: 120,
                                                            marginTop: "16px",
                                                            marginLeft: "0px"
                                                        }} fullWidth>
                                                            <InputLabel id="users-label">Dolgozók</InputLabel>
                                                            <Select
                                                                labelId="users-label"
                                                                multiple
                                                                value={task.users || []}
                                                                onChange={(e) => onUsersChange(e, "users")}
                                                                label="Dolgozók"
                                                                variant="outlined"
                                                                input={<OutlinedInput id="select-multiple-chip"
                                                                                      label="Dolgozók"/>}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        gap: 1.0,
                                                                        margin: "-5px"
                                                                    }}>
                                                                        {selected.map((value) => (
                                                                            <Chip key={value.id} label={value.name}/>
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                                MenuProps={MenuProps}
                                                            >
                                                                {users.map((user) => (
                                                                    <MenuItem
                                                                        key={user.id}
                                                                        value={user}
                                                                        style={getStyles(user.name, task.users)}
                                                                    >
                                                                        {user.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid size={{xs: 20, md: 10, lg: 5}}>
                                                        <FormControl sx={{
                                                            m: 1,
                                                            minWidth: 120,
                                                            marginTop: "16px",
                                                            marginLeft: "0px"
                                                        }} fullWidth>
                                                            <InputLabel id="clients-label">Ügyfelek</InputLabel>
                                                            <Select
                                                                labelId="clients-label"
                                                                multiple
                                                                value={task.clients || []}
                                                                onChange={(e) => onUsersChange(e, 'clients')}
                                                                label="Ügyfelek"
                                                                variant="outlined"
                                                                input={<OutlinedInput id="select-multiple-chip"
                                                                                      label="Ügyfelek"/>}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        gap: 1.0,
                                                                        margin: "-5px"
                                                                    }}>
                                                                        {selected.map((value) => (
                                                                            <Chip key={value.id} label={value.name}/>
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                                MenuProps={MenuProps}
                                                            >
                                                                {clients.map((client) => (
                                                                    <MenuItem
                                                                        key={client.id}
                                                                        value={client}
                                                                        style={getClientsStyles(client.name, task.clients)}
                                                                    >
                                                                        {client.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    {createInputField("contactName", "Kontakt Név", task.contactName, onChange, false, false, false, "text", false, 5)}
                                                    {createInputField("contactEmail", "Kontakt Email", task.contactEmail, onChange, false, false, false, "text", false, 5)}

                                                    {message &&
                                                        <Grid size={{xs: 20}}>
                                                            <Alert severity="error" variant="standard"
                                                                   style={{color: "red"}}>{message}</Alert>
                                                        </Grid>
                                                    }
                                                </>
                                            }

                                            <Grid size={{xs: 2, md: 30}} sx={{height: "50px"}}></Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                <Button type="button" fullWidth variant="contained" color="error"
                                                        onClick={() => navigate(-1)}>
                                                    Vissza
                                                </Button>
                                            </Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                <Tooltip title="Vissza és Olvasatlan">
                                                    <Button type="button" fullWidth variant="contained" color="secondary"
                                                            onClick={() => {
                                                                taskService.setSeen(id, false)
                                                                    .catch(error => console.error(error))
                                                                    .finally(() => navigate(-1))
                                                            }}>
                                                        <MarkAsUnread sx={{marginRight: "10px"}}/>
                                                        Vissza
                                                    </Button>
                                                </Tooltip>
                                            </Grid>

                                            <Grid size={{md: 24, lg: 14}}></Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                {!waitingForServer &&
                                                    <Button type="button" fullWidth variant="contained" color="primary"
                                                            onClick={() => saveAsNew()}>
                                                        Mentés Újként
                                                    </Button>}
                                            </Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                {waitingForServer ? <CircularProgress sx={{margin: "-5px"}}/> :
                                                    <Button type="submit" fullWidth variant="contained" color="success">
                                                        Mentés
                                                    </Button>}
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Grid size={{xs: 20}}>
                                        <Grid container columns={5} sx={{marginTop: "4px"}}>
                                            <Grid size={{xs: 5}}>
                                                <Table sx={{marginTop: "16px", tableLayout: props.task?.files?.length > 0 ? "fixed": ""}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell style={{fontWeight: 700, background: "lightgray", width: "100px"}}
                                                                       align='left' padding='none' sx={{paddingLeft: "8px"}}>
                                                                <Tooltip title={"Fájl feltöltése"}>
                                                                    <Button variant='contained' color='success' component={'label'}
                                                                            sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}>
                                                                        <VisuallyHiddenInput type="file" multiple onChange={props.handleFileChange}/>
                                                                        <Add fontSize="large"/>
                                                                    </Button>
                                                                </Tooltip>
                                                                {downloadInProgress ? <div style={{display: "inline-block", position: "relative"}}><CircularProgress size={"35px"} sx={{marginTop: "0px", position: "absolute", top: -22}}/></div> :
                                                                    <Tooltip title={"Összes letöltése"}>
                                                                        <Button variant='contained' color='warning' component={'label'} onClick={() => downloadAllFiles()}
                                                                                sx={{minWidth: "0px", padding: "0px", marginRight: "0px", paddingTop: "-10px"}}
                                                                                disabled={selectedFiles?.length <=0}
                                                                        >
                                                                            <Download fontSize="large"/>
                                                                        </Button>
                                                                    </Tooltip>
                                                                }
                                                            </TableCell>
                                                            {columns.map((column, index) => (
                                                                <TableCell key={index} align={column.align}
                                                                           style={{fontWeight: 700, background: "lightgray"}}>
                                                                    {column.label}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.task?.files?.length > 0 ? props.task?.files?.map((file, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{width: "100%", padding: "0px", height: "30px !important", display: "inline-flex", justifyContent: "space-between"}}>
                                                                    <Button
                                                                        onClick={() => props.removeDocumentName(file.id)}
                                                                        variant="text" color='error' sx={{
                                                                        margin: "0px",
                                                                        marginLeft: "0px",
                                                                        padding: "0px",
                                                                        position: "relative",
                                                                        minWidth: "24px",
                                                                        top: "0px",
                                                                        left: "0px"
                                                                    }}>
                                                                        <Delete/>
                                                                    </Button>
                                                                    <Box sx={{'& span': {padding: "0px"}}}>
                                                                        <Checkbox sx={{marginTop: "0px", position: "relative", marginRight: "70px", top: "3px", left: "0px", color: "gray", cursor: "pointer"}}
                                                                                    onClick={e => onFileCheckBoxChange(e, file)}/>
                                                                        </Box>
                                                                </TableCell>
                                                                <TableCell key={index} sx={{textAlign: "left", padding: "0px"}}>
                                                                    <Link
                                                                        onClick={() => download(file.name, `/cloud-storage-files/${file.id}`, props.sendAlertMessage)}
                                                                        sx={{
                                                                            textDecoration: "none",
                                                                            cursor: "pointer",
                                                                            fontWeight: "bold"
                                                                        }}>{file.name}</Link>
                                                                </TableCell>
                                                                <TableCell sx={{padding: "0px"}}>
                                                                    <span style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: "0px"}}>
                                                                        <span style={{flexGrow: 1, textAlign: 'left'}}>{file.description}</span>
                                                                        <Button onClick={() => handleClickOpen(file)} variant="text" sx={{minWidth: '0px', padding: '0px', marginLeft: 'auto'}}>
                                                                            <Edit/>
                                                                        </Button>
                                                                    </span>
                                                                </TableCell>

                                                                <TableCell sx={{padding: "0px"}}>{file.createdAt}</TableCell>
                                                                <TableCell sx={{padding: "0px"}}>{file.uploadedBy?.name}</TableCell>
                                                            </TableRow>
                                                        )) : <TableRow><TableCell colSpan={20} sx={{textAlign: "center", fontStyle: "italic"}}>Nincs feltöltött fájl</TableCell></TableRow>}
                                                        {props.files?.map((file, index) => (
                                                            <TableRow>
                                                                <TableCell sx={{width: "50px", padding: "0px"}}>
                                                                    <Button
                                                                        onClick={() => props.handleRemoveFile(index)}
                                                                        variant="text" color='error' sx={{
                                                                        marginLeft: "10px",
                                                                        padding: "5px",
                                                                        minWidth: "0px"
                                                                    }}>
                                                                        <Close/>
                                                                    </Button>
                                                                </TableCell>
                                                                <TableCell key={index} sx={{
                                                                    textAlign: "left",
                                                                    padding: "0px 0px 0px 5px"
                                                                }}>
                                                                    {file.name} {' ('}{(new Intl.NumberFormat().format((file.size / 1024).toFixed(2))).replace(',', '.')} KB{')'}
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>

                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </form>
                        </div>
                    </Grid>

                    {id && <Grid size={{xs: 20}}>
                        <TaskChatMessages/>
                    </Grid>}

                </Grid>
            </Container>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        props.updateFileDescription(currentItem.id, formJson)
                        handleClose();
                    },
                }}
            >
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Fájl Leírás Módosítása
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="description"
                        label="Leírás"
                        fullWidth
                        autoComplete="off"
                        defaultValue={currentItem?.description}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained"
                            sx={{marginRight: "auto"}}>Mentés</Button>
                    <Button onClick={handleClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

function createInputField(name, label, value, onChange, required = false, autoFocus = false, disabled = false, type = "text", multiline = false, lg = 10) {
    return (<Grid size={{xs: 40, md: 20, lg: lg}}>
        <TextField
            variant="outlined"
            margin="normal"
            required={required}
            fullWidth
            id={name}
            label={label}
            name={name}
            type={type}
            autoFocus={autoFocus}
            autoComplete="off"
            onChange={onChange}
            value={value || ""}
            disabled={disabled}
            multiline={multiline}
            minRows={multiline ? 5 : 1}
        />
    </Grid>)
}